import { makeStyles } from 'tss-react/mui';
import { get } from 'lodash';

export default makeStyles()((theme) => ({
  actions: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '30px',
  },
  error: {
    color: get(theme, 'palette.destructive.main'),
    maxWidth: '300px',
  },
  row: {
    padding: '15px 0px',
    minHeight: '100px',
    minWidth: '300px',
  },
  infoText: {
    marginTop: '15px',
    fontStyle: 'italic',
  },
  codeInput: {
    marginBottom: '25px',
    marginTop: '25px',
  },
}));
